export const BannerContentPositionEnum = {
    None: 0,
    Left: 1,
    Center: 2,
    Right: 3,
    Top: 4,
    Bottom: 5
};

export const BannerPositionEnum = {
    None: 'None',
    UpperLeft: 'UpperLeft',
    UpperCenter: 'UpperCenter',
    UpperRight: 'UpperRight',
    Main: 'Main',
    Right: 'Right',
    Left: 'Left',
    BottomLeft: 'BottomLeft',
    BottomCenter: 'BottomCenter',
    BottomRight: 'BottomRight'
};